import { DownTime } from "./DownTime";


export class RevertInfo {
    readonly downTimeToBeReverted: DownTime;
    readonly downTimesToRevert: DownTime[];

    constructor(downTime: DownTime, downTimesToRevert: DownTime[]) {
        this.downTimeToBeReverted = downTime;
        this.downTimesToRevert = downTimesToRevert;
    }
}